import Complexs from './complex.vue';

export default Complexs;



// WEBPACK FOOTER //
// ./src/components/complex/index.js